export const NODE_BASE_CLASS = 'border rounded-xl bg-neutral-900/70 border-neutral-800 p-2 shadow'
export const NODE_DASHED_CLASS = 'border-2 border-dashed rounded-2xl p-2 bg-white/5 border-neutral-700'

export const NODE_MIN = {
  default: { width: 160, height: 70 },
  subflow: { width: 260, height: 160 },
}
